/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var TEXT_SUFFIX = '.__text';

function evalPath(JSONPath, data, path) {
  try {
    return JSONPath({ path: path, json: data, wrap: true }) || [];
  } catch (e) {
    return [];
  }
}

function evalPathAll(JSONPath, data, path) {
  try {
    return JSONPath({ path: path, json: data, resultType: 'all', wrap: true }) || [];
  } catch (e) {
    return [];
  }
}

// Chrome's XML parser now drops redundant xmlns declarations that used to be
// repeated on child elements. x2js only wraps a leaf as {__text, $attr...}
// when the leaf carries attributes, so those leaves now arrive as bare
// strings instead. Blueprint paths ending in ".__text" then silently resolve
// to undefined. Walk the blueprint (mirroring jsonpath-object-transform's own
// traversal) and re-wrap any bare-string/number leaf a ".__text" path
// references, so the blueprint transform that runs right after this sees the
// shape it expects.
module.exports = function normalizeTextLeaves(JSONPath, data, blueprint) {
  if (!data || typeof data !== 'object') {
    return;
  }
  walk(JSONPath, data, blueprint);
};

function walk(JSONPath, data, blueprint) {
  if (typeof blueprint === 'string') {
    normalizeLeaf(JSONPath, data, blueprint);
  } else if ($.isArray(blueprint)) {
    var path = blueprint[0];
    var subBlueprint = blueprint[1];
    if (!subBlueprint) {
      return;
    }
    var items = evalPath(JSONPath, data, path);
    if (items.length && $.isArray(items[0])) {
      items[0].forEach(function(item) {
        walk(JSONPath, item, subBlueprint);
      });
    }
  } else if ($.isPlainObject(blueprint)) {
    $.each(blueprint, function(key, value) {
      walk(JSONPath, data, value);
    });
  }
}

function normalizeLeaf(JSONPath, data, path) {
  if (path.slice(-TEXT_SUFFIX.length) !== TEXT_SUFFIX) {
    return;
  }
  var basePath = path.slice(0, -TEXT_SUFFIX.length);
  evalPathAll(JSONPath, data, basePath).forEach(function(match) {
    var isTextLeaf = typeof match.value === 'string' || typeof match.value === 'number';
    if (isTextLeaf && match.parent) {
      match.parent[match.parentProperty] = { __text: match.value };
    }
  });
}
